import {tva} from "@gluestack-ui/nativewind-utils/tva";

export const formControlStyle = tva({
    base: "flex flex-col z-auto",
    variants: {
        size: {
            sm: "",
            md: "",
            lg: ""
        }
    }
});

export const formControlErrorIconStyle = tva({
    base: "font-body text-error-600 fill-none",
    variants: {}
});

export const formControlErrorStyle = tva({
    base: "flex flex-row justify-start items-center mt-2 gap-1"
});

export const formControlErrorTextStyle = tva({
    base: "font-body text-sm text-error-600 font-normal leading-sm",
    variants: {}
});

export const formControlHelperStyle = tva({
    base: "flex flex-row justify-start items-center mt-2"
});

export const formControlHelperTextStyle = tva({
    base: "font-body text-xs text-blueGray-400 leading-sm",
    variants: {}
});

export const formControlLabelStyle = tva({
    base: "flex flex-row justify-start items-center mb-1"
});

export const formControlLabelTextStyle = tva({
    base: "font-body text-xs font-medium text-blueGray-800 leading-sm",
    variants: {}
});

export const formControlLabelAstrickStyle = tva({
    base: "font-body text-xs font-medium text-error-600 leading-sm",
    variants: {}
});
